export default class AUTHENTICATION_CONSTANTS {
    static ACCESS_TOKEN_KEY = 'ACCESS_TOKEN';
    static ACTION = {
        LOGIN: 'login',
        REGISTER: 'register',
        FORGOT_PASSWORD: 'forgot-password'
    };
}
